import { useState } from 'react';

import { Tabs } from '@/shared/ui/tabs';
import { ThemeSwitcher } from '@/shared/ui/theme';

import { AtomsSection } from './sections/AtomsSection';
import { CompositesSection } from './sections/CompositesSection';
import { FoundationsSection } from './sections/FoundationsSection';
import { OverlaysSection } from './sections/OverlaysSection';
import { PanelsSection } from './sections/PanelsSection';
import { WindowsSection } from './sections/WindowsSection';

type SectionId = 'foundations' | 'atoms' | 'panels' | 'composites' | 'overlays' | 'windows';

const SECTIONS: Array<{ value: SectionId; label: string }> = [
  { value: 'foundations', label: 'Foundations' },
  { value: 'atoms', label: 'Atoms' },
  { value: 'panels', label: 'Panels' },
  { value: 'composites', label: 'Composites' },
  { value: 'overlays', label: 'Overlays' },
  { value: 'windows', label: 'Windows' },
];

export function DesignShowcasePage() {
  const [section, setSection] = useState<SectionId>('foundations');

  return (
    <div className="phx-root bg-phx-bg text-phx-text flex h-full flex-col">
      <header className="bg-phx-surface border-phx-border px-phx-7 py-phx-5 border-b">
        <div className="gap-phx-5 flex items-start justify-between">
          <div className="min-w-0">
            <h1 className="text-phx-h2 text-phx-text m-0 font-bold tracking-tight">
              Phoenix Design System
            </h1>
            <p className="mt-phx-2 text-phx-sm text-phx-text-muted m-0">
              Living showcase of every component in the shared/ui design system. Switch theme, mode
              and environment with the controls on the right — the change is applied instantly and
              persisted across reloads.
            </p>
          </div>
          <ThemeSwitcher />
        </div>
        <div className="mt-phx-5">
          <Tabs<SectionId> value={section} onChange={setSection} items={SECTIONS} />
        </div>
      </header>
      <div className="px-phx-7 py-phx-6 flex-1 overflow-auto">
        {section === 'foundations' && <FoundationsSection />}
        {section === 'atoms' && <AtomsSection />}
        {section === 'panels' && <PanelsSection />}
        {section === 'composites' && <CompositesSection />}
        {section === 'overlays' && <OverlaysSection />}
        {section === 'windows' && <WindowsSection />}
      </div>
    </div>
  );
}
